module.exports = __webpack_public_path__ + "media/images/banks/dbs-9a47e2708130810d9ebf2e461515c7ec.png";